// extracted by mini-css-extract-plugin
var _1 = "SquarishCardBase-module__animateUploadProgressBarWidth--i5Zs5";
var _2 = "SquarishCardBase-module__animatedBackground--i3C24";
var _3 = "SquarishCardBase-module__avatarContainer--Nvlxr";
var _4 = "SquarishCardBase-module__banner--oArpf";
var _5 = "SquarishCardBase-module__container--xkuGX";
var _6 = "SquarishCardBase-module__content--CGhtr";
var _7 = "SquarishCardBase-module__description--sRfD8";
var _8 = "SquarishCardBase-module__descriptionContent--r2W9J";
var _9 = "SquarishCardBase-module__footer--_omPD";
var _a = "SquarishCardBase-module__footerContent--RhNbD";
var _b = "SquarishCardBase-module__forceFooter--zBSCS";
var _c = "SquarishCardBase-module__header--yI03s";
var _d = "SquarishCardBase-module__hoverContainer--k6iBx";
var _e = "SquarishCardBase-module__icon--ZeR7r";
var _f = "SquarishCardBase-module__iconsBar--UFFAu";
var _10 = "SquarishCardBase-module__isOpen--nEEzN";
var _11 = "8";
var _12 = "SquarishCardBase-module__overflowMenu--eZqtv";
var _13 = "SquarishCardBase-module__overflowMenuButton--wtjnu";
var _14 = "SquarishCardBase-module__title--NJDqQ";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "avatarContainer", _4 as "banner", _5 as "container", _6 as "content", _7 as "description", _8 as "descriptionContent", _9 as "footer", _a as "footerContent", _b as "forceFooter", _c as "header", _d as "hoverContainer", _e as "icon", _f as "iconsBar", _10 as "isOpen", _11 as "maxDescriptionLines", _12 as "overflowMenu", _13 as "overflowMenuButton", _14 as "title" }
